<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <div
      class="back-mobile-btn"
      @click="goBack(routerBackName,'addressInfo')"
    >
      <i class="fa fa-arrow-left" />
    </div>
    <h3>
      {{ $t('preCheckIn.addressInfo.title') }}
    </h3>
    <el-form
      v-if="typeof userData.address !== 'undefined'"
      :model="userData.address"
      :rules="rules"
      ref="addressInfo"
      class="address-info pre-reg"
      label-position="top"
    >
      <el-row class="block">
        <el-row class="title">
          {{ $t('preCheckIn.addressInfo.formTitle') }}
        </el-row>
        <el-row class="data full">
          <el-form-item
            :label="$t('common.labels.street1')"
            prop="street1"
            :class="[{'focus': userData.address.street1}, 'is-required', 'street-field', {'is-notify': addressNotify}]"
          >
            <el-input
              type="text"
              v-model="userData.address.street1"
              @focus="addressNotify = false"
            />
            <span
              class="notify"
              v-if="addressNotify"
            >
              {{ $t('preCheckIn.addressInfo.notify') }}
            </span>
          </el-form-item>
        </el-row>
        <el-row class="data full">
          <el-form-item
            :label="$t('common.labels.apartment')"
            prop="street2"
            :class="{'focus': userData.address.street2}"
          >
            <el-input
              type="text"
              v-model="userData.address.street2"
            />
          </el-form-item>
        </el-row>
        <el-row
          class="data addr-data"
        >
          <el-form-item
            :label="$t('common.labels.city')"
            prop="city"
            :class="[{'focus': userData.address.city}, 'is-required', 'city']"
          >
            <el-input
              type="text"
              v-model="userData.address.city"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.state')"
            prop="state"
            :class="[{'focus': userData.address.state}, 'is-required', 'state']"
          >
            <el-select
              filterable
              v-model="userData.address.state"
            >
              <el-option
                v-for="(state, key) in states"
                :key="key"
                :label="state.name"
                :value="state.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.zip')"
            prop="zip"
            :class="[{'focus': userData.address.zip}, 'is-required', 'zip']"
          >
            <the-mask
              v-model.number="userData.address.zip"
              mask="#####"
            />
          </el-form-item>
        </el-row>
      </el-row>
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-buttons"
        >
          <el-button
            @click="goBack(routerBackName, 'addressInfo')"
            type="back"
          >
            {{ $t('common.buttons.back') }}
          </el-button>
          <el-row
            class="right-btn"
          >
            <el-button
              type="primary"
              @click="submitForm('addressInfo')"
            >
              {{ $t('common.buttons.next') }}
            </el-button>
          </el-row>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import store from "../../store";

export default {
  name: 'AddressInfo',
  data: () => {
    return {
      states: [],
      userData: {},
      fullscreenLoading: false,
      patientNumber: null,
      activeStep: null,
      routerName: 'EmergencyContact',
      routerBackName: 'ContactInfo',
      sid: null,
      addressNotify: false,
      rules: {},
      fields: ['street1', 'city', 'state', 'zip']
    };
  },
  watch: {
    'userData.address.street1': function (val) {
      if (val?.trim().length) this.changeField({ street: val });
    },
    'userData.address.street2': function (val) {
      if (val?.trim().length) this.changeField({apartment: val});
    },
    'userData.address.city': function (val) {
      if (val?.trim().length) this.changeField({city: val});
    },
    'userData.address.state': function (val) {
      if (val?.trim().length) this.changeField({state: val});
    },
    'userData.address.zip': function (val) {
      if (val != null && val !== '' && !isNaN(val)) this.changeField({zip: val});
    },
  },
  created () {
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.setRules(this.fields);
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    this.sid = this.getSessionId();

    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.patientNumber = store.getters.patientData.patientNumber;
        this.setData();
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.setData();
    }
  },
  methods: {
    async setData() {
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_AddressInfo: 'true'
      });

      try {
        const response = await this.getStates();
        if (!response.data.isSuccess) return;

        this.userData = JSON.parse(JSON.stringify(store.getters.patientData));
        this.states = response.data.data;

        const userDataResponse = await this.$axios.post(
            `${process.env.VUE_APP_INTERNAL_API}/api/getUserData`,
            { pid: this.userData.patientId }
        );

        if (userDataResponse.data) {
          const { driverLicenceData, street1 } = userDataResponse.data.appData;
          const hasValidStreet = (street) => street && street.includes(' ');

          if (
              (!driverLicenceData?.street1 && !street1?.length && !this.userData.address?.street1) ||
              (driverLicenceData?.street1 && !hasValidStreet(driverLicenceData?.street1)) ||
              (this.userData.address?.street1 && !hasValidStreet(this.userData.address?.street1)) ||
              (street1?.length && !hasValidStreet(street1))
          ) {
            this.addressNotify = true;
          }
        }

        await this.updateUserAppData(this.userData.patientId, {
          active_pr_step: this.activeStep,
          active_route: this.$route.name
        });

      } catch (error) {
        console.log(error);
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      } finally {
        this.fullscreenLoading = false;
      }
    },
    updateUserData() {
      this.updatePatientInfoData({
        patientId: this.userData.patientId,
        patientNumber: this.patientNumber,
        cellPhone: this.userData.cellPhone,
        street1: this.userData.address.street1,
        street2: this.userData.address.street2,
        city: this.userData.address.city,
        zip: this.userData.address.zip,
        state: this.userData.address.state
      }).then((response) => {
        store.dispatch('setPatientData', this.userData);
        if (response.data.isSuccess) {
          this.updateStepsData(this.userData.patientId, {[this.activeStep] : 1}).then((response) => {
            if (response.data.isSuccess) {
              this.updateUserAppData(this.userData.patientId, {
                street1: this.userData.address.street1,
                street2: this.userData.address.street2,
                city: this.userData.address.city,
                zip: this.userData.address.zip,
                state: this.userData.address.state
              }).then((response) => {
                if (response.data) {
                  if (response.data.isSuccess) {
                    this.fullscreenLoading = false;
                    this.$router.push({
                      name: this.routerName,
                      params: {
                        patientNumber: this.patientNumber
                      },
                    });
                  } else {
                    this.fullscreenLoading = false;
                    this.setMessage(
                      this.$t('common.errors.update', { type: this.$t('preCheckIn.addressInfo.title').toLowerCase() }),
                      'warning'
                    );
                  }
                }
              }).catch(() => {
                this.setMessage(this.$t('common.errors.update', { type: this.$t('preCheckIn.addressInfo.title').toLowerCase() }));
                this.fullscreenLoading = false;
              });
            } else {
              this.fullscreenLoading = false;
              this.setMessage(this.$t('common.errors.fail'));
            }
          });
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    },
    submitForm(formName) {
      this.fullscreenLoading = true;
      this.addressNotify = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveStatisticData(this.sid, {
            submit_AddressInfo: 'true'
          });
          this.updateUserData();
        } else {
          this.fullscreenLoading = false;
          return false;
        }
      });
    }
  }
};
</script>
